import React from 'react';
import { Box, Flex, HStack, Text, Button, Container, Image, Divider } from '@chakra-ui/react';
import { Link, useNavigate, Outlet } from 'react-router-dom';
import { applicantToken } from './careerApi';

export default function CareersLayout() {
  const navigate = useNavigate();
  const loggedIn = !!applicantToken.get();

  function logout() {
    applicantToken.clear();
    navigate('/');
  }

  return (
    <Box minH="100vh" bg="#F7F9FC" display="flex" flexDirection="column">
      <Box bg="white" borderBottom="1px solid #E5E9F0" position="sticky" top="0" zIndex="20" boxShadow="0 1px 0 rgba(0,0,0,0.02)">
        <Container maxW="1200px">
          <Flex h="72px" alignItems="center" justifyContent="space-between">
            <HStack spacing="14px" cursor="pointer" onClick={() => navigate('/')}>
              <Image src="/eocean-logo.png" alt="eOcean" h="34px" objectFit="contain" fallbackSrc="/hive-logo_old.png" />
              <Box display={{ base: 'none', sm: 'block' }}>
                <Text fontSize="11px" color="#94A3B8" letterSpacing="1.5px" textTransform="uppercase" fontWeight="700">Careers</Text>
              </Box>
            </HStack>

            <HStack spacing="6px">
              <Button as={Link} to="/" variant="ghost" size="sm" fontWeight="600" color="#334155">Open jobs</Button>
              {loggedIn ? (
                <>
                  <Button as={Link} to="/my-applications" variant="ghost" size="sm" fontWeight="600" color="#334155">My applications</Button>
                  <Button size="sm" onClick={logout} variant="outline" borderColor="#CBD5E1">Log out</Button>
                </>
              ) : (
                <>
                  <Button as={Link} to="/login" size="sm" variant="outline" borderColor="#CBD5E1" color="#334155" fontWeight="600">Log in</Button>
                  <Button as={Link} to="/signup" size="sm" bg="#1E76CE" color="white" _hover={{ bg: '#1A67B4' }} fontWeight="600" px="16px">Create account</Button>
                </>
              )}
            </HStack>
          </Flex>
        </Container>
      </Box>

      <Box flex="1">
        <Outlet />
      </Box>

      <Box bg="white" borderTop="1px solid #E5E9F0" py="32px" mt="40px">
        <Container maxW="1200px">
          <Flex justifyContent="space-between" flexWrap="wrap" gap="20px" alignItems="center">
            <HStack spacing="14px">
              <Image src="/eocean-logo.png" alt="eOcean" h="28px" objectFit="contain" opacity={0.85} />
            </HStack>
            <Text fontSize="12px" color="#94A3B8">
              © {new Date().getFullYear()} eOcean Technologies · Building the internet of the next billion.
            </Text>
            <HStack spacing="18px" fontSize="12px" color="#64748B">
              <Text as="a" href="https://eocean.net" target="_blank" _hover={{ color: '#1E76CE' }}>eocean.net</Text>
              <Text as={Link} to="/" _hover={{ color: '#1E76CE' }}>Careers</Text>
            </HStack>
          </Flex>
        </Container>
      </Box>
    </Box>
  );
}
